import { useRef } from "react";
import type { FormEvent, ReactNode } from "react";
import { Button, Dialog } from "@akin2unde/flowui-react";
import "./RightSideDialogCss.css";

interface RightSideDialogProps {
  Wide?: boolean;
  FooterContent?: ReactNode;
  IsOpen: boolean;
  Title: string;
  Description?: string;
  SaveLabel?: string;
  IsSaving?: boolean;
  Children: ReactNode;
  OnClose: () => void;
  OnSave: () => void | Promise<void>;
}

export default function RightSideDialogHTML(props: RightSideDialogProps) {
  const formRef = useRef<HTMLFormElement>(null);

  const submit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    if (!props.IsSaving) void props.OnSave();
  };

  return (
    <Dialog
      open={props.IsOpen}
      position="right"
      header={
        <div className="right-dialog-title">
          <h2>{props.Title}</h2>
          {props.Description && <p>{props.Description}</p>}
        </div>
      }
      body={
        <form ref={formRef} onSubmit={submit}>
          {props.Children}
        </form>
      }
      footer={
        <div className="right-dialog-actions">
          {props.FooterContent && <div className="editor-footer-total">{props.FooterContent}</div>}
          <Button type="button" variant="outline" onClick={props.OnClose}>
            Cancel
          </Button>
          <Button
            type="button"
            disabled={props.IsSaving}
            onClick={() => formRef.current?.requestSubmit()}
          >
            <i className="fa-solid fa-check" aria-hidden="true" />
            {props.SaveLabel ?? "Save"}
          </Button>
        </div>
      }
      closeOnOverlayClick
      closeOnEscape
      showCloseButton
      width={props.Wide ? "1040px" : "500px"}
      maxWidth="full"
      onClose={props.OnClose}
    />
  );
}
